import { Contact } from 'lib/api/contacts/types';
import React from 'react';
import { useMemo } from 'react';

import { SingleSelect } from '../../SingleSelect';
import { Aval } from '../types';

type Props = {
  aval: Aval;
  setAval: (aval: Aval) => void;
  value: Aval[];
  businessUsers: Contact[];
};

const SameCompany: React.FC<Props> = ({
  aval,
  setAval,
  value,
  businessUsers,
}) => {
  const setValue = (identifier: string) => {
    const signer = businessUsers?.find((u) => u.identifier === identifier);
    if (signer) {
      const newAval = {
        ...aval,
        signer: {
          identifier: signer.identifier,
          name: signer.name,
          email: signer.email,
          phone: signer.phone,
          country: signer.country,
          profession: signer.profession,
          maritalStatus: signer.maritalStatus,
        },
      };
      setAval(newAval);
    }
  };

  const getUserLabel = (user: Contact) => {
    if (!user.name) return '';
    const nameParts = user.name.split(' ').filter(Boolean);
    if (nameParts.length === 0) return '';
    if (nameParts.length === 1) return nameParts[0];
    return `${nameParts[0]} ${nameParts[1]}`;
  };

  const businessUsersOptions = useMemo(() => {
    const addedAvalIdentifiers = new Set(
      (value ?? [])
        .filter((a) => a.type === 'SAME_COMPANY' && a.signer?.identifier)
        .map((a) => a.signer!.identifier!),
    );

    return (businessUsers ?? [])
      .filter((user): user is Contact & { identifier: string } =>
        Boolean(user.identifier),
      )
      .map((user) => ({
        value: user.identifier,
        label: getUserLabel(user),
      }))
      .filter((option) => !addedAvalIdentifiers.has(option.value));
  }, [businessUsers, value]);

  return (
    <SingleSelect
      options={businessUsersOptions}
      value={aval?.signer?.identifier ?? ''}
      onChange={setValue}
      label="Aval empresa"
    />
  );
};

export default SameCompany;
